<template>
  <BoxWithTitle
    class="my-4"
    :collapsible="true"
  >
    <template v-slot:header>
      <v-toolbar-title>
        {{ $t('profile.signature.sectionTitle') }}
      </v-toolbar-title>
    </template>
    <template v-slot:content>
      <SignatureForm />
    </template>
  </BoxWithTitle>
</template>

<script>
import SignatureForm from '@/components/profile/SignatureForm';
import BoxWithTitle from '@/components/shared/containers/VBoxWithTitle.vue';

export default {
    components: {
        SignatureForm,
        BoxWithTitle,
    },
};
</script>
